import useDateUtility from "./useDateUtility";

export default function useRuleUtility() {

    const dateUtility = useDateUtility();

    return {
        ruleTypes: [
            { "name": "To Postcode", "value": 1, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "From Postcode", "value": 57, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Date (Window)", "value": 2, "dataType": "date", "conditions": [2] },
            { "name": "Date Time (Window)", "value": 3, "dataType": "datetime", "conditions": [2] },
            { "name": "Day of Week (Window)", "value": 4, "dataType": "dayOfWeek", "conditions": [2] },
            { "name": "Date (Current)", "value": 5, "dataType": "date", "conditions": [1, 2, 3, 4, 5, 6] },
            { "name": "Date Time (Current)", "value": 6, "dataType": "datetime", "conditions": [1, 2, 3, 4, 5, 6] },
            { "name": "Day of Week (Current)", "value": 7, "dataType": "dayOfWeek", "conditions": [1, 2] },
            { "name": "Date (Attribute)", "value": 8, "dataType": "date", "conditions": [1, 2] },
            { "name": "Date Time (Attribute)", "value": 9, "dataType": "datetime", "conditions": [1, 2] },
            { "name": "Day of Week (Attribute)", "value": 10, "dataType": "dayOfWeek", "conditions": [1, 2] },
            { "name": "Fulfillment Weight", "value": 11, "dataType": "decimal", "conditions": [1, 2, 3, 4, 5, 6] },
            { "name": "Fulfillment Quantity", "value": 12, "dataType": "int", "conditions": [1, 2, 3, 4, 5, 6] },
            { "name": "Fulfillment Value", "value": 13, "dataType": "decimal", "conditions": [1, 2, 3, 4, 5, 6] },
            { "name": "Fulfillment Product ID (All)", "value": 14, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Fulfillment Product ID (Any)", "value": 15, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Fulfillment Product SKU (All)", "value": 16, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Fulfillment Product SKU (Any)", "value": 17, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Fulfillment Product Barcode (All)", "value": 41, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Fulfillment Product Barcode (Any)", "value": 42, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Fulfillment Product Type (All)", "value": 43, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Fulfillment Product Type (Any)", "value": 44, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Fulfillment Product Tags (All)", "value": 45, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Fulfillment Product Tags (Any)", "value": 46, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Fulfillment Product Vendor (All)", "value": 47, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Fulfillment Product Vendor (Any)", "value": 48, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Fulfillment Product Title (All)", "value": 18, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Fulfillment Product Title (Any)", "value": 19, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Fulfillment Product Variant ID (All)", "value": 20, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Fulfillment Product Variant ID (Any)", "value": 21, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Fulfillment Product Attribute (All)", "value": 22, "dataType": "attribute", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Fulfillment Product Attribute (Any)", "value": 23, "dataType": "attribute", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Weight", "value": 24, "dataType": "decimal", "conditions": [1, 2, 3, 4, 5, 6] },
            { "name": "Order Quantity", "value": 25, "dataType": "int", "conditions": [1, 2, 3, 4, 5, 6] },
            { "name": "Order Value", "value": 26, "dataType": "decimal", "conditions": [1, 2, 3, 4, 5, 6] },
            { "name": "Order Product ID (All)", "value": 27, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Product ID (Any)", "value": 28, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Product SKU (All)", "value": 29, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Product SKU (Any)", "value": 30, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Product Barcode (All)", "value": 49, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Product Barcode (Any)", "value": 50, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Product Type (All)", "value": 51, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Product Type (Any)", "value": 52, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Product Tags (All)", "value": 53, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Product Tags (Any)", "value": 54, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Product Vendor (All)", "value": 55, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Product Vendor (Any)", "value": 56, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Product Title (All)", "value": 31, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Product Title (Any)", "value": 32, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Product Variant ID (All)", "value": 33, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Product Variant ID (Any)", "value": 34, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Product Attribute (All)", "value": 35, "dataType": "attribute", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Product Attribute (Any)", "value": 36, "dataType": "attribute", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Attribute", "value": 37, "dataType": "attribute", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Notes", "value": 38, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Order Tag", "value": 39, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] },
            { "name": "Shipping Title", "value": 40, "dataType": "string", "conditions": [1, 2, 7, 8, 9, 10, 11, 12] }
        ],
        conditions: [
            { "name": "Equals", "value": 1 },
            { "name": "Not Equals", "value": 2 },
            { "name": "Greater than", "value": 3 },
            { "name": "Greater than or equal to", "value": 4 },
            { "name": "Less than", "value": 5 },
            { "name": "Less than or equal to", "value": 6 },
            { "name": "Contains", "value": 7 },
            { "name": "Does Not Contain", "value": 8 },
            { "name": "Starts With", "value": 9 },
            { "name": "Does Not Start With", "value": 10 },
            { "name": "Ends With", "value": 11 },
            { "name": "Does Not End With", "value": 12 }
        ],
        getRuleType: function (value) {
            let valueFormatted = parseInt(value);
            return this.ruleTypes.find(x => x.value === valueFormatted);
        },
        getCondition: function (value) {
            let valueFormatted = parseInt(value);
            return this.conditions.find(x => x.value === valueFormatted);
        },
        toRuleEdit: function (rule, isPickupGroupType) {
            var dataType = rule ? this.getRuleDataType(rule.ruleType) : null;
            return rule
                ? {
                    "ruleType": rule.ruleType.toString(),
                    "condition": rule.condition.toString(),
                    "value": ["string", "int", "decimal", "attribute"].includes(dataType) ? rule.value : null,
                    "valueDate": dataType === "date" && ![1, 2].includes(rule.condition) ? new Date(rule.value) : null,
                    "valueDateTime": dataType === "datetime" && ![1, 2].includes(rule.condition) ? new Date(rule.value) : null,
                    "valueDates": dataType.startsWith("date") && [1, 2].includes(rule.condition) ? rule.value.split(",") : [],
                    "valueDayOfWeek": dataType === "dayOfWeek" ? rule.value : "1",
                    "orGroup": rule.orGroup
                }
                : {
                    "ruleType": isPickupGroupType? "2" : "1",
                    "condition": isPickupGroupType ? "2" : "1",
                    "valueDayOfWeek": "1",
                    "valueDate": null,
                    "valueDateTime": null,
                    "valueDates": [],
                    "orGroup": null
                };
        },
        okRule: function (rules, selectedRule, ruleEdit) {
            var sValues = (ruleEdit.value ?? "")
                .split(",")
                .map(x => x.trim())
                .filter((v, i, a) => v !== "" && a.indexOf(v) === i)
                .sort();

            if (ruleEdit.dataType !== "string"
                && !ruleEdit.dataType?.startsWith("date")
                && ruleEdit.dataType !== "dayOfWeek"
                && sValues.length < 1)
                return "Value is required.";

            if (ruleEdit.dataType === "attribute" && sValues.map(v => v.split(":")).find(v => v.length !== 2 || v[0].trim().length < 1))
                return "Invalid Value.";

            if (["int", "decimal"].includes(ruleEdit.dataType)
                && (ruleEdit.value?.includes(",") || sValues.find(v => isNaN(Number(v)))))
                return "Invalid Value.";

            if (ruleEdit.dataType?.startsWith("date")) {
                if (['1', '2'].includes(ruleEdit.condition) && ruleEdit.valueDates.length < 1)
                    return "At least one date is required.";

                if (!['1', '2'].includes(ruleEdit.condition)
                    && isNaN(Date.parse(ruleEdit.dataType === "date" ? ruleEdit.valueDate : ruleEdit.valueDateTime)))
                    return "A valid date is required.";
            }

            if (ruleEdit.dataType === "dayOfWeek" && (!ruleEdit.valueDayOfWeek || !["1", "2", "3", "4", "5", "6", "7"].includes(ruleEdit.valueDayOfWeek)))
                return "A valid date is required.";

            if (ruleEdit.orGroup && ruleEdit.orGroup.toString().trim().length > 0 && (ruleEdit.orGroup.toString().includes(".") || isNaN(Number(ruleEdit.orGroup.toString().trim())) || parseInt(ruleEdit.orGroup.toString().trim()) < 1))
                return "Invalid OR Group.";

            ruleEdit.orGroup = ruleEdit.orGroup && ruleEdit.orGroup.toString().trim().length > 0 ? parseInt(ruleEdit.orGroup.toString().trim()) : null;

            var valueFormatted = ruleEdit.dataType === "string" ? sValues.join(",")
                : ruleEdit.dataType === "int" ? sValues.map(v => parseInt(v).toString()).join(",")
                    : ruleEdit.dataType === "decimal" ? sValues.map(v => parseFloat(v).toString()).join(",")
                        : ruleEdit.dataType?.startsWith("date") && ['1', '2'].includes(ruleEdit.condition) ? ruleEdit.valueDates.map(v => ruleEdit.dataType === "date" ? dateUtility.toDateString(v) : dateUtility.toDateTimeString(v)).join(",")
                            : ruleEdit.dataType === "date" && !['1', '2'].includes(ruleEdit.condition) ? dateUtility.toDateString(ruleEdit.valueDate)
                                : ruleEdit.dataType === "datetime" && !['1', '2'].includes(ruleEdit.condition) ? dateUtility.toDateTimeString(ruleEdit.valueDateTime)
                                    : ruleEdit.dataType === "attribute" ? sValues.map(v => v.split(":")).map(v => `${v[0].trim()}:${v[1].trim()}`).join(",")
                                    : ruleEdit.valueDayOfWeek;

            if (selectedRule) {
                selectedRule.ruleType = parseInt(ruleEdit.ruleType);
                selectedRule.condition = parseInt(ruleEdit.condition);
                selectedRule.value = valueFormatted;
                selectedRule.orGroup = ruleEdit.orGroup;
            } else {
                rules.push({
                    "ruleType": parseInt(ruleEdit.ruleType),
                    "condition": parseInt(ruleEdit.condition),
                    "value": valueFormatted,
                    "orGroup": ruleEdit.orGroup
                });
            }

            return null;
        },
        addDate: function (ruleEdit) {
            if (!ruleEdit?.dataType?.startsWith("date")
                || !["1", "2"].includes(ruleEdit.condition)
                || (ruleEdit.dataType === "date" && !ruleEdit.valueDate)
                || (ruleEdit.dataType === "datetime" && !ruleEdit.valueDateTime))
                return;

            var valueFormatted = ruleEdit.dataType === "date"
                ? dateUtility.toDateString(ruleEdit.valueDate)
                : dateUtility.toDateTimeString(ruleEdit.valueDateTime);

            if (!ruleEdit.valueDates.find(d => d === valueFormatted))
                ruleEdit.valueDates.push(valueFormatted);

            ruleEdit.valueDate = null;
            ruleEdit.valueDateTime = null;
        },
        removeDate: function (ruleEdit, date) {
            if (!ruleEdit || !date)
                return;

            var dateFormatted = dateUtility.toDateTimeString(date);
            var idx = ruleEdit.valueDates.map(d => dateUtility.toDateTimeString(d)).indexOf(dateFormatted);

            if (idx >= 0)
                ruleEdit.valueDates.splice(idx, 1)
        }
    };
}
